module.exports = __webpack_public_path__ + "static/img/BE@3x.095552fc.jpg";